import FeaturedCardsPage from 'components/help_details/featured_cards_page'
export default FeaturedCardsPage
